<template>
  <div class="container exam">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>在线题库</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">在线题库</h2>
        </div>
        <div class="right">
          <el-badge :value="count_unhandle_bug"
                    class="item">
            <el-button class="button"
                       type="primary"
                       @click="handleToExamBugReport">题目报错</el-button>
          </el-badge>
          <el-button style="margin-left:16px;"
                     class="button"
                     type="primary"
                     @click="handleExamCreate">创建题库</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题库名称"
                      prop="name">
          <el-input v-model="query.name"
                    placeholder="输入题库名称"
                    @input="fetchExamList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="题库类型"
                      prop="exam_type">
          <el-select v-model="query.exam_type"
                     placeholder="请选择"
                     @change="fetchExamList(true)"
                     clearable>
            <el-option v-for="item in filter.types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="fetchExamList(true)"
                          :default-time="['00:00:00', '23:59:59']"
                          clearable>
          </el-date-picker>
        </el-form-item>

        <el-form-item label="学长搜索"
                      prop="name">
          <el-input v-model="query.author"
                    placeholder="输入学长手机号，真实姓名"
                    @input="fetchExamList(true)"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="query.creator"
                     placeholder="请选择"
                     @change="fetchExamList(true)"
                     clearable>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用科目"
                      prop="name">
          <el-input v-model="query.subject"
                    placeholder="输入适用科目"
                    @input="fetchExamList(true)"
                    style="width:300px;"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="search-footer">
        <!--        <div class="filter-item">
          <span class="label">排序方式</span>
          <div class="values">
            <span
              :class="
                item.value == query.sort ? 'value-item active' : 'value-item'
              "
              v-for="item in filter.sorts"
              :key="item.value"
              @click="handleFilterChange(item.value, 'sort')"
              >{{ item.label }}</span
            >
          </div>
        </div> -->
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">题库列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.status"
                            @change="fetchExamList()">
              <el-radio-button v-for="(item, index) in filter.status"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabs">
        <el-tabs v-model="tabName"
                 @tab-click="handleTabChange">
          <el-tab-pane label="全部商品"
                       name="all"></el-tab-pane>
          <el-tab-pane label="学长商品"
                       name="senior"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="values">
        <!--  <ExamCard class="exam-item" :content="item" :noUp="index == 0" :noDown="index == results.length-1" @remove="handleExamRemove" @reload="fetchExamList" @sort="handleSortChange" v-for="(item, index) in results" :key="item.id"/> -->
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">

              {{ scope.row.id }}

            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="主图"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-image style="height: 50px"
                        :src="scope.row.picture_url"
                        fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="title"
                           width="300"
                           label="题库名称"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="题库类型"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateExam_type(scope.row.exam_type) }}
            </template>
          </el-table-column>
          <el-table-column prop="price"
                           label="售价"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.price > 0">{{
                scope.row.price + "元"
              }}</span>
              <span v-else>免费</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="总题数"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.item_count + "题" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="在学数"
                           prop="trial_count"
                           align="center"
                           width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.user_count - scope.row.virtual_count }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="试用次数"
                           prop="trial_count"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.trial_count > 0">{{
                scope.row.trial_count + "次"
              }}</span>
              <span v-else>不可试用</span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort"
                           label="排序值"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="学长"
                           width="180"
                           align="center"
                           v-if="query.is_author==1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{scope.row.author.mobile }}</span></template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="200"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goDetail(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPreview(scope.row)">浏览</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToClone(scope.row.id)">克隆</el-link>
              <el-link type="danger
            "
                       @click="handleExamRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="goDetail(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom:6px;"><span @click="handleToPreview(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handleToClone(scope.row.id)"
                          style="font-size:16px;color: #409EFF;">
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom:6px;"><span @click="handleExamRemove(scope.row.id)"
                          style="font-size:16px;color: #F56C6C;">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ExamCard from '@/components/card/Exam'
import { examList, examDestroy, examsUpdate, examClone } from '@/api/exam'

export default {
  components: {
    ExamCard,
  },
  data() {
    return {
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        exam_type: '',
        status: '1',
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        types: [
          { label: '全部', value: '' },
          { label: '考点练习', value: 1 },
          { label: '冲刺押题', value: 2 },
          { label: '历年真题', value: 3 },
          { label: '挑战刷题', value: 4 },
          { label: '名师题库', value: 5 },
          { label: '参考书配套题库', value: 6 },
        ],
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
      count_unhandle_bug: 0,
    }
  },
  created() {
    this.parseQuery()
    this.fetchExamList()
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  methods: {
    // 题库列表请求
    fetchExamList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      examList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
        this.count_unhandle_bug = res.count_unhandle_bug
      })
      this.syncQuery()
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchExamList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchExamList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchExamList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchExamList()
      }, 20)
    },
    // 题库创建
    handleExamCreate() {
      this.$router.push(`/exam/create`)
    },
    // 排序位置变化
    handleSortChange(row, type) {
      const list = this.results
      const index = list.findIndex((v) => v.id == row.id)
      list.splice(index, 1)
      if (type == 'up') {
        list.splice(index - 1, 0, row)
      } else if (type == 'down') {
        list.splice(index + 1, 0, row)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examsUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('排序更新异常')
          console.log('error: ', error)
        })
    },
    // 题库删除
    handleExamRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          examDestroy({ id: examId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchExamList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.exam_type) {
        this.query.exam_type = Number(this.query.exam_type)
      }
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      this.tabName = this.query.is_author == 1 ? 'senior' : 'all'
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateExam_type(id) {
      if (id) {
        return this.filter.types.find((v) => {
          return v.value == id
        }).label
      } else {
        return '无'
      }
    },
    // 表格操作跳转页面
    goDetail(item) {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://admin.kaoyanbox.com/exam/detail/${item.id}`)
      } else {
        this.$router.push(`/exam/detail/${item.id}`)
      }
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/exam/detail/${item.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/exam/detail/${item.id}`)
        }
      }
    },
    handleToClone(id) {
      // 二次确认
      this.$confirm('确定要复制吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          examClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`)
            this.fetchExamList()
          })
        })
        .catch(() => {})
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchExamList(true)
    },
    handleToExamBugReport() {
      this.$router.push(`/exam/bugreport`)
    },
  },
}
</script>

<style scoped lang="less">
.exam {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
    /deep/.el-badge__content {
      line-height: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
}
</style>
